// Pelo nome do pacote: o Vite segue o campo "exports" (condição "import" ->
// dist/main.mjs, o build ESM). O caminho direto `dist/main.mjs`, que o webpack 4
// precisava para não cair no build IIFE do campo "browser", não é exportado e o
// Vite recusa.
import { Player } from "@gumlet/player.js";

// Única porta para a biblioteca do Gumlet: o componente do vídeo só conhece
// esta função, e os testes trocam ela por um player falso.
//
// `handlers` = { ready, play, pause, ended, timeupdate({ seconds, duration }), error }.
// Os outros eventos só são assinados depois do `ready` — é o que a doc do
// Gumlet pede (https://docs.gumlet.com/developers/video-player/playerjs).
export function criarPlayerGumlet(iframe, handlers) {
  const player = new Player(iframe);

  player.on("ready", () => {
    player.on("play", () => handlers.play());
    player.on("pause", () => handlers.pause());
    player.on("ended", () => handlers.ended());
    player.on("timeupdate", (dados) => handlers.timeupdate(dados || {}));
    player.on("error", () => handlers.error());
    handlers.ready();
  });

  return {
    play: () => player.play(),
    mute: () => player.mute(),
    setCurrentTime: (segundos) => player.setCurrentTime(segundos),
    destroy: () => player.destroy(),
  };
}
